<p-dialog
  [visible]="visible"
  [modal]="true"
  [showHeader]="false"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="noHeader"
  [style]="{ width: '420px', maxWidth: '92vw' }"
  [baseZIndex]="10000"
  (onHide)="close()">
  <div class="nr-block">
    <button type="button" class="nr-block__close" aria-label="Close" (click)="close()">
      <i class="pi pi-times"></i>
    </button>

    <div class="nr-block__icon">
      <i class="pi pi-hourglass"></i>
    </div>

    <h3 class="nr-block__title">Not ready for No Response yet</h3>
    <p class="nr-block__subtitle">
      Keep working this lead — <span class="_fw-600">{{ blockedStatus || 'No Response' }}</span> unlocks once both steps below are done.
    </p>

    <div class="nr-block__steps">
      <div class="nr-block__step" [class.is-met]="hasEnoughTouchpoints">
        <span class="nr-block__step-label">Sales touchpoints</span>
        <span class="nr-block__step-value">
          {{ touchpoints }}<small *ngIf="required">/{{ required }}</small>
        </span>
        <div class="nr-block__bar">
          <span [style.width.%]="progressPercent"></span>
        </div>
        <span class="nr-block__step-note">
          <ng-container *ngFor="let channel of channels; let last = last">
            {{ channel.count }} {{ channel.label }}<ng-container *ngIf="!last"> · </ng-container>
          </ng-container>
        </span>
      </div>

      <!-- Clickable while a follow-up is still to book: it opens the picker below instead of sending the
           agent off to find the flag button. -->
      <div
        class="nr-block__step"
        [class.is-met]="requirement?.follow_up_completed"
        [class.is-booked]="!!bookedFollowUpLabel && !requirement?.follow_up_completed"
        [class.is-action]="canBookFollowUp"
        [class.is-active]="isFollowUpPickerOpen"
        [attr.role]="canBookFollowUp ? 'button' : null"
        [attr.tabindex]="canBookFollowUp ? 0 : null"
        (click)="toggleFollowUpPicker()"
        (keydown.enter)="toggleFollowUpPicker()">
        <span class="nr-block__step-label">Follow-up</span>
        <ng-container *ngIf="requirement?.follow_up_completed">
          <span class="nr-block__step-status"><i class="pi pi-check-circle"></i> Completed</span>
          <span class="nr-block__step-note">A follow-up was completed in this period.</span>
        </ng-container>
        <ng-container *ngIf="!requirement?.follow_up_completed && bookedFollowUpLabel">
          <span class="nr-block__step-status"><i class="pi pi-calendar"></i> Booked</span>
          <span class="nr-block__step-note">{{ bookedFollowUpLabel }} — mark it completed once done.</span>
        </ng-container>
        <ng-container *ngIf="canBookFollowUp">
          <span class="nr-block__step-status"><i class="pi pi-circle"></i> Pending</span>
          <span class="nr-block__step-cta"><i class="pi" [ngClass]="isFollowUpPickerOpen ? 'pi-angle-up' : 'pi-plus'"></i> Add follow-up</span>
        </ng-container>
      </div>
    </div>

    <div class="nr-block__picker" *ngIf="isFollowUpPickerOpen && canBookFollowUp">
      <div class="nr-block__picker-head">
        <span>When should we follow up?</span>
        <i class="pi pi-spin pi-spinner" *ngIf="isFollowUpSaving || !canAddFollowUp"></i>
      </div>

      <div class="nr-block__presets">
        <button
          type="button"
          class="nr-block__preset"
          *ngFor="let item of followUpOptions"
          [disabled]="isFollowUpSaving || !canAddFollowUp"
          (click)="pickPreset(item)">
          <span>{{ item.label }}</span>
          <small>{{ item.display }}</small>
        </button>
      </div>

      <div class="nr-block__custom">
        <p-calendar
          [(ngModel)]="pickedDate"
          [minDate]="today"
          [ngModelOptions]="{ standalone: true }"
          placeholder="Pick date"
          dateFormat="dd/mm/yy"
          appendTo="body"
          [firstDayOfWeek]="1"></p-calendar>
        <ng-select
          [items]="timerOptions"
          bindLabel="label"
          bindValue="value"
          [searchable]="true"
          [clearable]="true"
          placeholder="Time"
          appendTo="body"
          [(ngModel)]="pickedTime"
          [ngModelOptions]="{ standalone: true }"></ng-select>
        <button
          type="button"
          class="_outline-btn"
          [disabled]="!pickedDate || !pickedTime || isFollowUpSaving || !canAddFollowUp"
          (click)="savePickedDate()">
          Save
        </button>
      </div>
    </div>

    <p class="nr-block__footnote" *ngIf="keptStatus">Lead stays on {{ keptStatus }}</p>

    <button type="button" class="_primary-btn nr-block__ok" (click)="close()">Got it</button>
  </div>
</p-dialog>
